export default __webpack_public_path__ + "static/media/logo138x75black.1a197989.png";